/**
 * Every screen of the customer app: its path, its title (the page title and
 * the nav label). One table, so a screen never acquires two names.
 *
 * Competitor insights replaces the retired Market Spy surface.
 */
export type Screen = {
  path: string;
  title: string;
};

export const SCREENS = {
  performance: { path: '/performance', title: 'Performance' },
  overview: { path: '/overview', title: 'Overview' },
  // One screen, two views (Top insights, By attribute); Comparison is a drawer on either.
  // The /attribute-analysis paths redirect (features/attribute-insights/legacy.ts).
  attributeInsights: { path: '/attribute-insights', title: 'Attribute insights' },
  attributeExplore: { path: '/attribute-insights/explore', title: 'Attribute insights by attribute' },
  competitorInsights: { path: '/competitor-insights', title: 'Competitor insights' },
  creativeLab: { path: '/creative-lab', title: 'Creative lab' },
  creativeLabProject: { path: '/creative-lab/projects/$projectId', title: 'Creative lab project' },
  creativeLabReplacement: { path: '/creative-lab/projects/new', title: 'Brief a replacement' },
  attributes: { path: '/attributes', title: 'Attributes' },
  alerts: { path: '/alerts', title: 'Alerts' },
  aiResizing: { path: '/image-resize', title: 'AI resizing' },
  revenueForecasts: { path: '/predictive-analytics', title: 'Revenue forecasts' },
  forecastAdmin: { path: '/predictive-analytics/admin', title: 'Forecast administration' },
  connections: { path: '/connections', title: 'Connections' },
  metricWeights: { path: '/target-metrics', title: 'Metric weights' },
  apiAccess: { path: '/api-access', title: 'API & MCP' },
  users: { path: '/users', title: 'Users' },
  billing: { path: '/balance', title: 'Billing' },
  noConnections: { path: '/no-connections', title: 'No connections' },
  tiktokAdsConnected: { path: '/tiktok-ads-connected', title: 'TikTok Ads connection' },
  googleAdsConnected: { path: '/google-ads-connected', title: 'Google Ads connected' },
  youtubeConnected: { path: '/youtube-connected', title: 'YouTube connected' },
  metaAdsLogin: { path: '/meta-ads-login', title: 'Connect Meta Ads' },
  oauthConsent: { path: '/oauth/consent', title: 'Authorize access' },
  login: { path: '/login', title: 'Sign in' },
  signup: { path: '/signup', title: 'Sign up' },
  verification: { path: '/auth', title: 'Account verification' },
  forgotPassword: { path: '/forgot-password', title: 'Reset password' },
  resetPassword: { path: '/reset', title: 'Choose new password' },
  supportSession: { path: '/support-session', title: 'Support session' },
  notFound: { path: '/$', title: 'Page not found' },
} as const satisfies Record<string, Screen>;

export type ScreenId = keyof typeof SCREENS;

